import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import { SummerOfCricketPromoCard } from './SummerOfCricketPromoCard'

export const SummerOfCricketPromoCardRegistration = createRegisterableComponent(
    'summer-of-cricket-promo-card',
    () => <SummerOfCricketPromoCard />,
)
